var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-navbar",
    {
      staticClass: "white-bg navbar-main",
      attrs: { toggleable: "md", "data-trackname": "navbar" }
    },
    [
      _c(
        "b-navbar-brand",
        {
          staticClass: "navbar-brand-k",
          attrs: { to: { name: "Map" }, "data-trackname": "topNavbarBrand" }
        },
        [
          _c("img", {
            attrs: {
              src: require("@/assets/img/logo_nedgia-icon.png"),
              alt: "Nedgia"
            }
          })
        ]
      ),
      _vm._v(" "),
      _c("b-navbar-toggle", { attrs: { target: "nav_collapse" } }),
      _vm._v(" "),
      _c(
        "b-collapse",
        {
          staticClass: "justify-content-between",
          attrs: { "is-nav": "", id: "nav_collapse" }
        },
        [
          _c("b-navbar-nav", [
            _vm.isMap
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-empty",
                    on: { click: _vm.toggleLayers }
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-reorder",
                      staticStyle: { "padding-left": "0em" }
                    })
                  ]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "b-navbar-nav",
            { staticStyle: { width: "80%", "min-width": "75rem" } },
            [
              _vm.isPre
                ? _c(
                    "h3",
                    {
                      staticStyle: {
                        "margin-top": "4px",
                        color: "red",
                        width: "380px"
                      }
                    },
                    [_vm._v("Entorno de test")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isMap ? _c("searchBar") : _vm._e(),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "btn btn-empty",
                  attrs: { href: "mailto:" + _vm.supportEmail, target: "_top" }
                },
                [
                  _vm._v("\n        Soporte y Ayuda\n        "),
                  _c("i", { staticClass: "fa fa-question-circle" })
                ]
              ),
              _vm._v(" "),
              _c(
                "b-dropdown",
                {
                  staticClass: "nav-user",
                  attrs: { variant: "outline-primary" }
                },
                [
                  _c("template", { slot: "button-content" }, [
                    _c(
                      "span",
                      {
                        on: {
                          mouseover: function($event) {
                            _vm.ishover = true
                          },
                          mouseout: function($event) {
                            _vm.ishover = false
                          }
                        }
                      },
                      [
                        _vm.notCount > 0
                          ? _c("b-badge", { attrs: { variant: "dark" } }, [
                              _vm._v(_vm._s(_vm.notCount))
                            ])
                          : _c("span", { staticClass: "fa-stack" }, [
                              _c("i", {
                                staticClass: "fa fa-circle fa-stack-2x"
                              }),
                              _vm._v(" "),
                              _c("i", {
                                staticClass: "fa fa-user fa-stack-1x fa-inverse"
                              })
                            ]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.user.username))])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-dropdown-item",
                    {
                      attrs: { "data-trackname": "navbarBtnLogout" },
                      on: {
                        click: function($event) {
                          _vm.showNotifications = true
                        }
                      }
                    },
                    [
                      _vm.notCount > 0
                        ? _c("b-badge", { attrs: { variant: "dark" } }, [
                            _vm._v(_vm._s(_vm.notCount))
                          ])
                        : _vm._e(),
                      _vm._v("\n          Notificaciones\n        ")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "dropdown-divider" }),
                  _vm._v(" "),
                  _c(
                    "b-dropdown-item",
                    {
                      attrs: { "data-trackname": "navbarBtnLogout" },
                      on: { click: _vm.logout }
                    },
                    [_vm._v("\n          Salir\n        ")]
                  )
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("HelpSidePanel", { ref: "helpPanel" }),
      _vm._v(" "),
      _vm.isMap
        ? _c("div", { ref: "layersPanel", staticClass: "sidebar" }, [
            _c("div", { staticClass: "sidebar-container" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-8" }, [
                  _c("img", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      src: require("@/assets/img/logo_nedgia.png"),
                      alt: "Logo"
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-4" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn  btn-outline-primary",
                      class: { "btn-primary": _vm.help },
                      on: { click: _vm.toggleLayers }
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-close",
                        staticStyle: {
                          "margin-right": "0rem",
                          "padding-left": "0em"
                        }
                      })
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "nav nav-pills flex-column border-top mt-4" },
                [
                  _vm._l(_vm.layersList, function(group) {
                    return _c(
                      "div",
                      {
                        key: group.name,
                        staticClass: "section-group-collapse"
                      },
                      [
                        _vm.hasPermision(group, "V") ||
                        (_vm.hasPermision(group, "A") && group.name === "Red")
                          ? [
                              group.name === "Comercial"
                                ? [
                                    _c(
                                      "li",
                                      { staticClass: "nav-item" },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "btn btn-empty",
                                            on: {
                                              click: function($event) {
                                                _vm.toggleGroupOptions(
                                                  _vm.comercial
                                                )
                                              }
                                            }
                                          },
                                          [
                                            !_vm.comercial.show
                                              ? _c("i", {
                                                  staticClass:
                                                    "fa fa-chevron-down"
                                                })
                                              : _c("i", {
                                                  staticClass:
                                                    "fa fa-chevron-up"
                                                })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-form-checkbox",
                                          {
                                            attrs: {
                                              indeterminate:
                                                _vm.comercial.indeterminate,
                                              inline: ""
                                            },
                                            on: {
                                              change: function($event) {
                                                _vm.toggleComercialGroup(
                                                  $event,
                                                  _vm.comercial
                                                )
                                              }
                                            },
                                            model: {
                                              value: _vm.comercial.active,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.comercial,
                                                  "active",
                                                  $$v
                                                )
                                              },
                                              expression: "comercial.active"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(_vm.comercial.name) +
                                                "\n                  "
                                            ),
                                            _vm.isComercialFiltered
                                              ? _c("i", {
                                                  staticClass: "fa fa-filter"
                                                })
                                              : _vm._e()
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.comercial.show &&
                                    _vm.comercial.actions &&
                                    _vm.comercial.actions.length > 0
                                      ? _c(
                                          "b-button-group",
                                          {
                                            staticClass: "group-btn-actions",
                                            attrs: { size: "sm" }
                                          },
                                          [
                                            _vm._l(
                                              _vm.comercial.actions,
                                              function(action) {
                                                return [
                                                  _vm.hasPermision(
                                                    _vm.comercial,
                                                    action.p
                                                  )
                                                    ? _c(
                                                        "b-button",
                                                        {
                                                          key: action.name,
                                                          attrs: {
                                                            variant:
                                                              "outline-primary"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.executeFunction(
                                                                action.function,
                                                                "comercial"
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("i", {
                                                            class: action.icon,
                                                            attrs: {
                                                              "aria-hidden":
                                                                "true"
                                                            }
                                                          })
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.comercial.show
                                      ? _c(
                                          "li",
                                          { staticClass: "etiquetas-btn" },
                                          [
                                            _c(
                                              "b-form-checkbox",
                                              {
                                                attrs: { inline: "" },
                                                on: {
                                                  change: function($event) {
                                                    _vm.toggleLabel(group)
                                                  }
                                                },
                                                model: {
                                                  value: _vm.comercialLabels,
                                                  callback: function($$v) {
                                                    _vm.comercialLabels = $$v
                                                  },
                                                  expression: "comercialLabels"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  Etiquetas\n                "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.comercial.show
                                      ? _vm._l(_vm.comercial.layers, function(
                                          layer,
                                          i
                                        ) {
                                          return _c(
                                            "li",
                                            { key: i, staticClass: "sub-item" },
                                            [
                                              _c("switches", {
                                                staticClass: "nav-switch",
                                                staticStyle: {
                                                  "margin-top": ".5rem"
                                                },
                                                attrs: {
                                                  "emit-on-mount": false,
                                                  value:
                                                    _vm.comercial.layers[i]
                                                      .active,
                                                  color: "blue"
                                                },
                                                on: {
                                                  input: function($event) {
                                                    _vm.toggleComercialLayer(
                                                      $event,
                                                      i,
                                                      _vm.comercial
                                                    )
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "nav-subitem-span"
                                                },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: require("../../assets/img/icons/" +
                                                        layer.id +
                                                        ".png")
                                                    }
                                                  }),
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.capitalizeFirstLetter(
                                                          layer.categoria_gn_comercial
                                                        )
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                  layer.count
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass: "smaller"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "(" +
                                                              _vm._s(
                                                                layer.count.toLocaleString()
                                                              ) +
                                                              ")"
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        })
                                      : _vm._e()
                                  ]
                                : group.name === "Caldera"
                                ? [
                                    _c(
                                      "li",
                                      { staticClass: "nav-item" },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "btn btn-empty",
                                            on: {
                                              click: function($event) {
                                                _vm.toggleGroupOptions(
                                                  _vm.caldera
                                                )
                                              }
                                            }
                                          },
                                          [
                                            !_vm.caldera.show
                                              ? _c("i", {
                                                  staticClass:
                                                    "fa fa-chevron-down"
                                                })
                                              : _c("i", {
                                                  staticClass:
                                                    "fa fa-chevron-up"
                                                })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-form-checkbox",
                                          {
                                            attrs: {
                                              indeterminate:
                                                _vm.caldera.indeterminate,
                                              inline: ""
                                            },
                                            on: {
                                              change: function($event) {
                                                _vm.toggleComercialGroup(
                                                  $event,
                                                  _vm.caldera
                                                )
                                              }
                                            },
                                            model: {
                                              value: _vm.caldera.active,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.caldera,
                                                  "active",
                                                  $$v
                                                )
                                              },
                                              expression: "caldera.active"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(_vm.caldera.name) +
                                                "\n                  "
                                            ),
                                            _vm.isCalderaFiltered
                                              ? _c("i", {
                                                  staticClass: "fa fa-filter"
                                                })
                                              : _vm._e()
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.caldera.show &&
                                    _vm.caldera.actions &&
                                    _vm.caldera.actions.length > 0
                                      ? _c(
                                          "b-button-group",
                                          {
                                            staticClass: "group-btn-actions",
                                            attrs: { size: "sm" }
                                          },
                                          [
                                            _vm._l(
                                              _vm.caldera.actions,
                                              function(action) {
                                                return [
                                                  _vm.hasPermision(
                                                    _vm.caldera,
                                                    action.p
                                                  )
                                                    ? _c(
                                                        "b-button",
                                                        {
                                                          key: action.name,
                                                          attrs: {
                                                            variant:
                                                              "outline-primary"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.executeFunction(
                                                                action.function,
                                                                "caldera"
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("i", {
                                                            class: action.icon,
                                                            attrs: {
                                                              "aria-hidden":
                                                                "true"
                                                            }
                                                          })
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.caldera.show
                                      ? _vm._l(_vm.caldera.layers, function(
                                          layer,
                                          i
                                        ) {
                                          return _c(
                                            "li",
                                            {
                                              key:
                                                layer.categoria_gn_caldera +
                                                "caldera",
                                              staticClass: "sub-item"
                                            },
                                            [
                                              _c("switches", {
                                                staticClass: "nav-switch",
                                                staticStyle: {
                                                  "margin-top": ".5rem"
                                                },
                                                attrs: {
                                                  "emit-on-mount": false,
                                                  value:
                                                    _vm.caldera.layers[i]
                                                      .active,
                                                  color: "blue"
                                                },
                                                on: {
                                                  input: function($event) {
                                                    _vm.toggleComercialLayer(
                                                      $event,
                                                      i,
                                                      _vm.caldera
                                                    )
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "nav-subitem-span"
                                                },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: require("../../assets/img/icons/cald_" +
                                                        layer.id +
                                                        ".png"),
                                                      height: "15",
                                                      width: "15"
                                                    }
                                                  }),
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.capitalizeFirstLetter(
                                                          layer.categoria_gn_caldera
                                                        )
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                  layer.count
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass: "smaller"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "(" +
                                                              _vm._s(
                                                                layer.count.toLocaleString()
                                                              ) +
                                                              ")"
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        })
                                      : _vm._e()
                                  ]
                                : group.name === "Territorio"
                                ? [
                                    _c(
                                      "li",
                                      { staticClass: "nav-item" },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "btn btn-empty",
                                            on: {
                                              click: function($event) {
                                                _vm.toggleGroupOptions(group)
                                              }
                                            }
                                          },
                                          [
                                            !group.show
                                              ? _c("i", {
                                                  staticClass:
                                                    "fa fa-chevron-down"
                                                })
                                              : _c("i", {
                                                  staticClass:
                                                    "fa fa-chevron-up"
                                                })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-form-checkbox",
                                          {
                                            attrs: {
                                              indeterminate:
                                                group.indeterminate,
                                              inline: ""
                                            },
                                            on: {
                                              input: function($event) {
                                                _vm.toggleGroup(group)
                                              }
                                            },
                                            model: {
                                              value: group.active,
                                              callback: function($$v) {
                                                _vm.$set(group, "active", $$v)
                                              },
                                              expression: "group.active"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(group.name) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    group.show &&
                                    group.actions &&
                                    group.actions.length > 0
                                      ? _c(
                                          "b-button-group",
                                          {
                                            staticClass: "group-btn-actions",
                                            attrs: { size: "sm" }
                                          },
                                          [
                                            _vm._l(group.actions, function(
                                              action
                                            ) {
                                              return [
                                                _vm.hasPermision(
                                                  group,
                                                  action.p
                                                )
                                                  ? _c(
                                                      "b-button",
                                                      {
                                                        key: action.name,
                                                        attrs: {
                                                          variant:
                                                            "outline-primary"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            _vm.executeFunction(
                                                              action.function,
                                                              group
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("i", {
                                                          class: action.icon,
                                                          attrs: {
                                                            "aria-hidden":
                                                              "true"
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            })
                                          ],
                                          2
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    group.show
                                      ? _vm._l(group.layers, function(layer) {
                                          return _c(
                                            "li",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: _vm.ShowTerritorio(
                                                    layer
                                                  ),
                                                  expression:
                                                    "ShowTerritorio(layer)"
                                                }
                                              ],
                                              key: layer.name,
                                              staticClass: "sub-item"
                                            },
                                            [
                                              _c("switches", {
                                                staticClass: "nav-switch",
                                                staticStyle: {
                                                  "margin-top": ".5rem"
                                                },
                                                attrs: { color: "blue" },
                                                on: {
                                                  input: function($event) {
                                                    _vm.toggleLayer(
                                                      layer,
                                                      group
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value: layer.active,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      layer,
                                                      "active",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "layer.active"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "nav-subitem-span"
                                                },
                                                [
                                                  layer.icon_name
                                                    ? _c("img", {
                                                        attrs: {
                                                          src: require("../../assets/img/icons/" +
                                                            layer.icon_name +
                                                            ".png"),
                                                          height: "15",
                                                          width: "15"
                                                        }
                                                      })
                                                    : _vm._e(),
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.capitalizeFirstLetter(
                                                          layer.name
                                                        )
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                  layer.count
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass: "smaller"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "(" +
                                                              _vm._s(
                                                                layer.count.toLocaleString()
                                                              ) +
                                                              ")"
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        })
                                      : _vm._e()
                                  ]
                                : [
                                    _c(
                                      "li",
                                      { staticClass: "nav-item" },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "btn btn-empty",
                                            on: {
                                              click: function($event) {
                                                _vm.toggleGroupOptions(group)
                                              }
                                            }
                                          },
                                          [
                                            !group.show
                                              ? _c("i", {
                                                  staticClass:
                                                    "fa fa-chevron-down"
                                                })
                                              : _c("i", {
                                                  staticClass:
                                                    "fa fa-chevron-up"
                                                })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-form-checkbox",
                                          {
                                            attrs: {
                                              indeterminate:
                                                group.indeterminate,
                                              inline: ""
                                            },
                                            on: {
                                              input: function($event) {
                                                _vm.toggleGroup(group)
                                              }
                                            },
                                            model: {
                                              value: group.active,
                                              callback: function($$v) {
                                                _vm.$set(group, "active", $$v)
                                              },
                                              expression: "group.active"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(group.name) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    group.show &&
                                    group.actions &&
                                    group.actions.length > 0
                                      ? _c(
                                          "b-button-group",
                                          {
                                            staticClass: "group-btn-actions",
                                            attrs: { size: "sm" }
                                          },
                                          [
                                            _vm._l(group.actions, function(
                                              action
                                            ) {
                                              return [
                                                _vm.hasPermision(
                                                  group,
                                                  action.p
                                                )
                                                  ? _c(
                                                      "b-button",
                                                      {
                                                        key: action.name,
                                                        attrs: {
                                                          variant:
                                                            "outline-primary"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            _vm.executeFunction(
                                                              action.function,
                                                              group
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("i", {
                                                          class: action.icon,
                                                          attrs: {
                                                            "aria-hidden":
                                                              "true"
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            })
                                          ],
                                          2
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    group.show
                                      ? _vm._l(group.layers, function(layer) {
                                          return _c(
                                            "li",
                                            {
                                              key: layer.name,
                                              staticClass: "sub-item"
                                            },
                                            [
                                              _c("switches", {
                                                staticClass: "nav-switch",
                                                staticStyle: {
                                                  "margin-top": ".5rem"
                                                },
                                                attrs: { color: "blue" },
                                                on: {
                                                  input: function($event) {
                                                    _vm.toggleLayer(
                                                      layer,
                                                      group
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value: layer.active,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      layer,
                                                      "active",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "layer.active"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "nav-subitem-span"
                                                },
                                                [
                                                  layer.icon_name
                                                    ? _c("img", {
                                                        attrs: {
                                                          src: require("../../assets/img/icons/" +
                                                            layer.icon_name +
                                                            ".png"),
                                                          height: "15",
                                                          width: "15"
                                                        }
                                                      })
                                                    : _vm._e(),
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.capitalizeFirstLetter(
                                                          layer.name
                                                        )
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                  layer.count
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass: "smaller"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "(" +
                                                              _vm._s(
                                                                layer.count.toLocaleString()
                                                              ) +
                                                              ")"
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        })
                                      : _vm._e()
                                  ]
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  }),
                  _vm._v(" "),
                  [
                    _c(
                      "li",
                      {
                        staticClass: "nav-item",
                        on: { click: _vm.toggleComerciosGoogle }
                      },
                      [
                        _c("button", { staticClass: "btn btn-empty" }, [
                          !_vm.showComerciosGoogle
                            ? _c("i", { staticClass: "fa fa-chevron-down" })
                            : _c("i", { staticClass: "fa fa-chevron-up" })
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "btn",
                            staticStyle: { color: "#6b757c" }
                          },
                          [_vm._v("Externos")]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.showComerciosGoogle
                      ? [
                          _c(
                            "li",
                            { staticClass: "sub-item" },
                            [
                              _c("switches", {
                                staticClass: "nav-switch",
                                staticStyle: { "margin-top": ".5rem" },
                                attrs: { color: "blue" },
                                on: { input: _vm.toggleGoogle },
                                model: {
                                  value: _vm.comerciosGoogle,
                                  callback: function($$v) {
                                    _vm.comerciosGoogle = $$v
                                  },
                                  expression: "comerciosGoogle"
                                }
                              }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  "\n              Comercios Google\n            "
                                )
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            { staticClass: "sub-item" },
                            [
                              _c("switches", {
                                staticClass: "nav-switch",
                                staticStyle: { "margin-top": ".5rem" },
                                attrs: { color: "blue" },
                                on: { input: _vm.toggleKmz },
                                model: {
                                  value: _vm.kmz,
                                  callback: function($$v) {
                                    _vm.kmz = $$v
                                  },
                                  expression: "kmz"
                                }
                              }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  "\n              Capa archivo KMZ/KML " +
                                    _vm._s(
                                      _vm.kmzFilename
                                        ? "(" + _vm.kmzFilename + ")"
                                        : ""
                                    ) +
                                    "\n            "
                                )
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            {
                              staticClass: "sub-item btn text-left",
                              on: {
                                click: function($event) {
                                  _vm.openKMLDialog()
                                }
                              }
                            },
                            [
                              _c("span", [
                                _c("i", { staticClass: "fa fa-globe" }),
                                _vm._v(" Cargar archivo KML\n            ")
                              ])
                            ]
                          )
                        ]
                      : _vm._e()
                  ],
                  _vm._v(" "),
                  _vm.hasPermision({ rol: "GESTION COMERCIAL" }, "A") ||
                  _vm.hasPermision({ rol: "GESTION COMERCIAL" }, "V")
                    ? [
                        _c(
                          "li",
                          {
                            staticClass: "nav-item",
                            on: {
                              click: function($event) {
                                _vm.showGestionComercial = !_vm.showGestionComercial
                              }
                            }
                          },
                          [
                            _c("button", { staticClass: "btn btn-empty" }, [
                              !_vm.showGestionComercial
                                ? _c("i", { staticClass: "fa fa-chevron-down" })
                                : _c("i", { staticClass: "fa fa-chevron-up" })
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "btn",
                                staticStyle: { color: "#6b757c" }
                              },
                              [_vm._v("Gestión comercial")]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.showGestionComercial
                          ? [
                              _vm.hasPermision(
                                { rol: "GESTION COMERCIAL" },
                                "A"
                              )
                                ? [
                                    _vm.hasPermision(
                                      { rol: "GESTION COMERCIAL" },
                                      "V"
                                    ) ||
                                    _vm.hasPermision(
                                      { rol: "GESTION COMERCIAL" },
                                      "A"
                                    )
                                      ? _c(
                                          "li",
                                          {
                                            staticClass: "sub-item btn",
                                            staticStyle: {
                                              "text-align": "left"
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.manageLotes()
                                              }
                                            }
                                          },
                                          [
                                            _c("span", [
                                              _c("i", {
                                                staticClass: "fa fa-archive"
                                              }),
                                              _vm._v(" Lotes\n              ")
                                            ])
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                : [
                                    _c(
                                      "li",
                                      {
                                        staticClass: "sub-item btn text-left",
                                        on: {
                                          click: function($event) {
                                            _vm.manageVisits()
                                          }
                                        }
                                      },
                                      [
                                        _c("span", [
                                          _c("i", {
                                            staticClass: "fa fa-bar-chart"
                                          }),
                                          _vm._v(
                                            " Resumen visitas\n              "
                                          )
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "li",
                                      {
                                        staticClass: "sub-item btn text-left",
                                        on: {
                                          click: function($event) {
                                            _vm.manageVisitsEntities()
                                          }
                                        }
                                      },
                                      [
                                        _c("span", [
                                          _c("i", {
                                            staticClass: "fa fa-calendar"
                                          }),
                                          _vm._v(
                                            " Visitas entidades\n              "
                                          )
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "li",
                                      {
                                        staticClass: "sub-item btn",
                                        staticStyle: { "text-align": "left" },
                                        on: {
                                          click: function($event) {
                                            _vm.manageLotes()
                                          }
                                        }
                                      },
                                      [
                                        _c("span", [
                                          _c("i", {
                                            staticClass: "fa fa-archive"
                                          }),
                                          _vm._v(" Lotes\n              ")
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "li",
                                      {
                                        staticClass: "sub-item btn",
                                        staticStyle: { "text-align": "left" },
                                        on: {
                                          click: function($event) {
                                            _vm.showPotential()
                                          }
                                        }
                                      },
                                      [
                                        _c("span", [
                                          _c("i", {
                                            staticClass: "fa fa-book"
                                          }),
                                          _vm._v(
                                            " Estudio de potencial Residencial\n              "
                                          )
                                        ])
                                      ]
                                    )
                                  ]
                            ]
                          : _vm._e()
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasPermision({ rol: "SISTEMA" }, "B") ||
                  _vm.hasPermision({ rol: "SISTEMA" }, "V")
                    ? [
                        _c(
                          "li",
                          {
                            staticClass: "nav-item",
                            on: {
                              click: function($event) {
                                _vm.showSistema = !_vm.showSistema
                              }
                            }
                          },
                          [
                            _c("button", { staticClass: "btn btn-empty" }, [
                              !_vm.showSistema
                                ? _c("i", { staticClass: "fa fa-chevron-down" })
                                : _c("i", { staticClass: "fa fa-chevron-up" })
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "btn",
                                staticStyle: { color: "#6b757c" }
                              },
                              [_vm._v("Sistema")]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.showSistema
                          ? [
                              _vm.hasPermision({ rol: "SISTEMA" }, "V")
                                ? _c(
                                    "li",
                                    {
                                      staticClass: "sub-item btn",
                                      staticStyle: { "text-align": "left" },
                                      on: { click: _vm.manageUsers }
                                    },
                                    [
                                      _c("span", [
                                        _c("i", { staticClass: "fa fa-user" }),
                                        _vm._v(
                                          " Gestión usuarios\n            "
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hasPermision({ rol: "SISTEMA" }, "B")
                                ? _c(
                                    "li",
                                    {
                                      staticClass: "sub-item btn",
                                      staticStyle: { "text-align": "left" },
                                      on: {
                                        click: function($event) {
                                          _vm.manageAlerts = true
                                        }
                                      }
                                    },
                                    [
                                      _c("span", [
                                        _c("i", {
                                          staticClass:
                                            "fa fa-exclamation-circle"
                                        }),
                                        _vm._v(" Gestión alertas\n            ")
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "li",
                                {
                                  staticClass: "sub-item btn text-left",
                                  on: {
                                    click: function($event) {
                                      _vm.altaEntidad()
                                    }
                                  }
                                },
                                [
                                  _c("span", [
                                    _c("i", {
                                      staticClass: "fa fa-pencil-square-o"
                                    }),
                                    _vm._v(" Gestión entidades\n            ")
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "li",
                                {
                                  staticClass: "sub-item btn text-left",
                                  on: { click: _vm.logsActividad }
                                },
                                [
                                  _c("span", [
                                    _c("i", { staticClass: "fa fa-search" }),
                                    _vm._v(" Logs de Actividad\n              ")
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _vm.hasPermision({ rol: "SISTEMA" }, "V")
                                ? _c(
                                    "li",
                                    {
                                      staticClass: "sub-item btn",
                                      staticStyle: { "text-align": "left" },
                                      on: { click: _vm.manageCierreLotes }
                                    },
                                    [
                                      _c("span", [
                                        _c("i", {
                                          staticClass: "fa fa-archive"
                                        }),
                                        _vm._v(" Cierre lotes\n            ")
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          : _vm._e()
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      staticClass: "btn-navbar",
                      on: { click: _vm.saveVisibility }
                    },
                    [
                      _c("span", { staticClass: "btn" }, [
                        _c("i", { staticClass: "fa fa-map pl-0 mr-2" }),
                        _vm._v(" Guardar visibilidad")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      staticClass: "btn-navbar",
                      on: { click: _vm.savePosition }
                    },
                    [
                      _c("span", { staticClass: "btn" }, [
                        _c("i", { staticClass: "fa fa-map pl-0 mr-2" }),
                        _vm._v(" Guardar posición actual")
                      ])
                    ]
                  )
                ],
                2
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.userLoaded
        ? _c("FilterModal", {
            ref: "filtercomercial",
            style:
              _vm.filtermodal === "comercial"
                ? "display:initial"
                : "display:none",
            attrs: {
              optsfiltros: _vm.optsfiltros,
              filtros: _vm.filtros,
              type: "comercial"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.userLoaded
        ? _c("FilterModal", {
            ref: "filtercaldera",
            style:
              _vm.filtermodal === "caldera"
                ? "display:initial"
                : "display:none",
            attrs: {
              optsfiltros: _vm.optsfiltroscaldera,
              filtros: _vm.filtroscaldera,
              type: "caldera"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showUsersManagement
        ? _c("UsersManagement", { attrs: { permisos: _vm.permisos } })
        : _vm._e(),
      _vm._v(" "),
      _vm.showCierreLotesManagement
        ? _c("CierreLotesManagement", { attrs: { permisos: _vm.permisos } })
        : _vm._e(),
      _vm._v(" "),
      _vm.manageAlerts ? _c("ManageAlerts") : _vm._e(),
      _vm._v(" "),
      _vm.showLotes
        ? _c("LotesPopUp", {
            ref: "lotespopup",
            attrs: {
              permisos: _vm.permisos,
              user: _vm.user.username,
              parentoptsfiltros: _vm.optsfiltros,
              parentoptsfiltroscaldera: _vm.optsfiltroscaldera
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showManageVisitsPopup
        ? _c("ManageVisits", { attrs: { permisos: _vm.permisos } })
        : _vm._e(),
      _vm._v(" "),
      _vm.showManageVisitsEntitiesPopup
        ? _c("ManageVisitsEntities", { attrs: { permisos: _vm.permisos } })
        : _vm._e(),
      _vm._v(" "),
      _vm.showInfoPopUp
        ? _c("InfoPopUp", { attrs: { type: _vm.infoType } })
        : _vm._e(),
      _vm._v(" "),
      _vm.showAltaEntidadPopup ? _c("AltaEntidad") : _vm._e(),
      _vm._v(" "),
      _vm.showLogsActividad ? _c("LogsActividad") : _vm._e(),
      _vm._v(" "),
      _vm.showNotifications
        ? _c("Notifications", {
            attrs: { notifications: _vm.notifications, alert: false }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showAlerts
        ? _c("Notifications", {
            attrs: { notifications: _vm.alerts, alert: true }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        { ref: "genericmodal", attrs: { id: "generic", "ok-only": "" } },
        [_c("p", { staticClass: "my-4" }, [_vm._v(_vm._s(_vm.textgeneric))])]
      ),
      _vm._v(" "),
      _vm.PotentialResults
        ? _c(
            "div",
            [
              _c("PotentialResults", {
                attrs: { geom_geojson: _vm.geom_geojson },
                on: { hide: _vm.hidePotential2 }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Layout/Navbar.vue?vue&type=template&id=72b2e796&
// module id = null
// module chunks = 